// extracted by mini-css-extract-plugin
module.exports = {"form":"mobile-upload_form__1xGb1","preview":"mobile-upload_preview__2_-s6","formContainer":"mobile-upload_formContainer__V6PNM","image":"mobile-upload_image__2bLr_"};